import React, {} from 'react';
const styles = {"highlight":"Highlight-module__highlight__W6Q3A"};
/** A phrase underlined in orange inside a title, such as "ask for" in the landing page's headline. */
export function Highlight({ children }) {
    return React.createElement("mark", { className: styles.highlight }, children);
}
//# sourceMappingURL=Highlight.js.map